import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-editor-custom-component-conquistas',
  templateUrl: 'conquistas.component.html'
})
export class ConquistasComponent {
    @Input() item: any;
}
